export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    const manifestUrl = `${process.env.PUBLIC_URL}/asset-manifest.json`;
    const buildKey = '@AllDeliveryPWA:build';
    let reloading = false;

    const clearPwaCaches = async () => {
      if (!('caches' in window)) return;
      const keys = await window.caches.keys();
      await Promise.all(
        keys
          .filter((key) => key.startsWith('all-delivery-pwa-'))
          .map((key) => window.caches.delete(key))
      );
    };

    const reloadForUpdate = async () => {
      if (reloading) return;
      reloading = true;
      await clearPwaCaches().catch(() => {});
      window.location.reload();
    };

    const activateWaitingWorker = (registration) => {
      if (registration?.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    };

    const checkBuildVersion = async (registration) => {
      try {
        const response = await fetch(`${manifestUrl}?update=${Date.now()}`, { cache: 'no-store' });
        if (!response.ok) return;
        const manifest = await response.json();
        const buildId = manifest?.files?.['main.js'] || '';
        if (!buildId) return;

        const previousBuildId = localStorage.getItem(buildKey);
        localStorage.setItem(buildKey, buildId);
        if (previousBuildId && previousBuildId !== buildId) {
          await registration?.update().catch(() => {});
          activateWaitingWorker(registration);
          await reloadForUpdate();
        }
      } catch (_) {
        // Sem internet: mantem o PWA funcionando com o cache atual.
      }
    };

    navigator.serviceWorker.addEventListener('controllerchange', reloadForUpdate);

    navigator.serviceWorker.register(swUrl, { updateViaCache: 'none' })
      .then((registration) => {
        registration.update().catch(() => {});
        activateWaitingWorker(registration);
        checkBuildVersion(registration);

        window.setInterval(() => {
          registration.update().catch(() => {});
          activateWaitingWorker(registration);
          checkBuildVersion(registration);
        }, 60 * 1000);

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
            activateWaitingWorker(registration);
            checkBuildVersion(registration);
          }
        });

        window.addEventListener('focus', () => checkBuildVersion(registration));
        window.addEventListener('online', () => checkBuildVersion(registration));
        window.addEventListener('pageshow', () => checkBuildVersion(registration));
      })
      .catch(() => {
        // O aplicativo continua funcionando mesmo se o registro do PWA falhar.
      });
  });
}
